import React from 'react';
import './BillIcon.css';

/**
 * BillIcon - A reusable component for displaying bill icons
 * Shows the custom icon_url if available, otherwise falls back to category emoji
 * 
 * IMPORTANT: Container width is ALWAYS the same for a given size variant,
 * whether showing an image or emoji. This ensures bill names align vertically.
 * 
 * @param {string} iconUrl - The bill's custom icon URL (base64 or URL)
 * @param {string} categoryIcon - The fallback category emoji
 * @param {string} billName - The bill name (for alt text)
 * @param {string} size - Size variant: 'xs', 'sm', 'md', 'lg', 'xl'
 * @param {string} className - Additional CSS classes
 */
function BillIcon({ 
  iconUrl, 
  categoryIcon = '📋', 
  billName = 'Bill', 
  size = 'md',
  className = '' 
}) {
  const sizeClass = `bill-icon-${size}`;
  const hasImage = !!iconUrl;
  
  if (hasImage) {
    return (
      <div className={`bill-icon-wrapper ${sizeClass} has-image ${className}`}>
        <img 
          src={iconUrl} 
          alt={billName}
          className="bill-icon-image"
          onError={(e) => {
            // If image fails to load, hide it and show fallback
            e.target.style.display = 'none';
            if (e.target.nextSibling) {
              e.target.nextSibling.style.display = 'flex';
            }
          }}
        />
        <span className="bill-icon-fallback" style={{ display: 'none' }}>
          {categoryIcon}
        </span>
      </div>
    );
  }
  
  // Emoji-only - same container size as image for alignment
  return (
    <div className={`bill-icon-wrapper ${sizeClass} emoji-only ${className}`}>
      <span className="bill-icon-emoji">{categoryIcon}</span>
    </div>
  );
}

export default BillIcon;
